/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_cat_h1 = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.category} Converter`)
};

const es_uc_cat_h1 = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversor de ${i?.category}`)
};

const de_uc_cat_h1 = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.category}-Umrechner`)
};

const nl_uc_cat_h1 = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.category} Convertor`)
};

const fr_uc_cat_h1 = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Convertisseur ${i?.category}`)
};

const it_uc_cat_h1 = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Convertitore di ${i?.category}`)
};

const pt_br2_uc_cat_h1 = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversor de ${i?.category}`)
};

const pt_uc_cat_h1 = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversor de ${i?.category}`)
};

const ja_uc_cat_h1 = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.category}コンバーター`)
};

const zh_uc_cat_h1 = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ category: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_cat_h1 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_cat_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_cat_h1", locale)
	if (locale === "en") return en_uc_cat_h1(inputs)
	if (locale === "es") return es_uc_cat_h1(inputs)
	if (locale === "de") return de_uc_cat_h1(inputs)
	if (locale === "nl") return nl_uc_cat_h1(inputs)
	if (locale === "fr") return fr_uc_cat_h1(inputs)
	if (locale === "it") return it_uc_cat_h1(inputs)
	if (locale === "pt-BR") return pt_br2_uc_cat_h1(inputs)
	if (locale === "pt") return pt_uc_cat_h1(inputs)
	if (locale === "ja") return ja_uc_cat_h1(inputs)
	return zh_uc_cat_h1(inputs)
};